import React, { createContext, useContext, useEffect, useState } from 'react';

interface RTLContextType {
  isRTL: boolean;
  setRTL: (rtl: boolean) => void;
}

const RTLContext = createContext<RTLContextType | undefined>(undefined);

export const useRTL = () => {
  const context = useContext(RTLContext);
  if (context === undefined) {
    throw new Error('useRTL must be used within an RTLProvider');
  }
  return context;
};

interface RTLProviderProps {
  children: React.ReactNode;
}

export const RTLProvider: React.FC<RTLProviderProps> = ({ children }) => {
  const [isRTL, setIsRTL] = useState(false);

  const setRTL = (rtl: boolean) => {
    setIsRTL(rtl);
    document.documentElement.dir = rtl ? 'rtl' : 'ltr';
    document.documentElement.lang = rtl ? 'ar' : 'en';
  };

  useEffect(() => {
    const savedLang = localStorage.getItem('i18nextLng');
    const shouldUseRTL = savedLang === 'ar';
    setRTL(shouldUseRTL);
  }, []);

  return (
    <RTLContext.Provider value={{ isRTL, setRTL }}>
      {children}
    </RTLContext.Provider>
  );
};